import script from "./SearchUserGroupInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUserGroupInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchUserGroupInput.vue?vue&type=style&index=0&id=ca79dca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca79dca0"]])

export default __exports__